import { useState } from 'react'
import * as S from './EditorSearchBar.styled'
import { useSetRecoilState } from 'recoil'
import { getAssetsByName } from '@/api/assets'
import { useErrorHandler } from '@/hooks/utility/useErrorHandler'
import { Input } from '@/components/priority'
import { editorSearchBarLoading, editorSearchBarResults } from '@/atoms'

export const EditorSearchBar = ({
  selected,
  setSelectedMenu,
  setShowSlideout,
  menu,
  ...props
}) => {
  const handleError = useErrorHandler('EditorSearchBar')
  const [value, setValue] = useState('')
  const setEditorSearchBarResults = useSetRecoilState(editorSearchBarResults)
  const setEditorSearchBarLoading = useSetRecoilState(editorSearchBarLoading)

  const getAssets = async () => {
    const trimmedValue = value.trim()
    if (trimmedValue === '') return

    try {
      setEditorSearchBarLoading(true)
      setSelectedMenu(menu)
      setShowSlideout(menu)
      const { data } = await getAssetsByName(value)
      const { assets } = data
      if (assets.length === 0) {
        setEditorSearchBarResults('No Matching Results')
      } else {
        setEditorSearchBarResults(assets)
      }
      setEditorSearchBarLoading(false)
    } catch (error) {
      handleError(error?.response?.data?.message || error.message, error)
    }
  }

  const handleKeyDown = (key) => {
    if (key === 'Enter') getAssets()
    else if (key === 'Escape') setShowSlideout(false)
  }
  return (
    <S.EditorSearchBar
      align="center"
      justify="space-between"
      height="54px"
      borderBottom="1px solid"
      borderColor="gray4"
      clickable
      {...props}
    >
      <Input
        value={[value, setValue]}
        width="77%"
        margin="0 0 0 12px"
        {...props}
        onKeyDown={({ key }) => handleKeyDown(key)}
      />
      <S.SearchIcon
        selected={selected}
        icon="search"
        fill="gray2"
        margin="0 12px 0 0"
        onClick={() => getAssets()}
      />
    </S.EditorSearchBar>
  )
}

export default EditorSearchBar
